import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_CONTRATOS_URL}${process.env.VUE_APP_API_PATH}/contratos`

// Todas as chamadas do modulo retornam, em caso de erro, um bad request com a
// mensagem. Normaliza esse corpo em { success: false, mensagem } para que os
// componentes apenas exibam a mensagem, sem tratar formato de erro.
function tratarErro(error) {
    let corpo = errorHandler(error)
    if (!corpo) {
        return null
    }
    return { success: false, mensagem: obterMensagem(corpo) }
}

function obterMensagem(corpo) {
    if (typeof corpo === 'string') {
        return corpo
    }
    if (corpo.message) {
        return corpo.message
    }
    if (Array.isArray(corpo.errors)) {
        return corpo.errors.join(' ')
    }
    if (corpo.errors) {
        return String(corpo.errors)
    }
    return 'Não foi possível concluir a operação.'
}

export default {
    obterItens(filtro) {
        let filtroAplicado = filtro ? filtro : {}
        return axiosJwt
            .get(
                `${api}/meeventos/itens?codigoContrato=${
                    filtroAplicado.codigoContrato
                        ? filtroAplicado.codigoContrato
                        : ''
                }&statusIntegracao=${
                    filtroAplicado.statusIntegracao
                        ? filtroAplicado.statusIntegracao
                        : 0
                }`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return tratarErro(error)
            })
    },

    obterContratos() {
        return axiosJwt
            .get(`${api}/meeventos/itens/contratosvigentes`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return tratarErro(error)
            })
    },

    obterCategorias() {
        return axiosJwt
            .get(`${api}/meeventos/categorias`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return tratarErro(error)
            })
    },

    obterItensContrato(idContrato) {
        return axiosJwt
            .get(`${api}/meeventos/itens/${idContrato}/principais`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return tratarErro(error)
            })
    },

    obterSubItens(idContrato, idItem) {
        return axiosJwt
            .get(
                `${api}/meeventos/itens/${idContrato}/principais/${idItem}/subitens`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return tratarErro(error)
            })
    },

    integrar(id, integracao) {
        return axiosJwt
            .post(`${api}/${id}/itenscontrato/selecionaritensintegracao`, integracao)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return tratarErro(error)
            })
    },

    obterOpcoesFiltros() {
        return axiosJwt
            .get(`${api}/meeventos/itens/opcoesfiltros`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return tratarErro(error)
            })
    }
}
